import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { User } from '../../interfaces/user';
import { Responses } from '../../interfaces/responses';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  urlBase = environment.urlBase;

  constructor(private http: HttpClient) {}

  // Función para subir archivos al server
  uploadImage(image: any) {
    return this.http.post(this.urlBase + 'auth/uploadImage', image, {
      reportProgress: true,
      observe: 'events',
    });
  }
  // Función para registrar el usuario
  registroUsuarios(user: any): Observable<any> {
    return this.http.post(`${this.urlBase}auth/createUser`, user);
  }
  // Obtenemos todos los registros de usuarios
  getUsers(): Observable<Responses> {
    return this.http.post<Responses>(`${this.urlBase}auth/getUsers`, null);
  }
  // Función para obtener los analistas
  getAnalyst(): Observable<Responses> {
    return this.http.post<Responses>(`${this.urlBase}auth/getAnalyst`, null);
  }
  // Función para actualizar el usuario
  updateUser(user: User): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}auth/updateUser/${user.Id}`,
      user
    );
  }
  // Función para eliminar el usuario
  deleteUser(user: User): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}auth/deleteUser/${user.Id}`,
      null
    );
  }
  // Funcion para contar los usuarios
  userCount(): Observable<Responses> {
    return this.http.post<Responses>(`${this.urlBase}auth/countUsers`, null);
  }

  getUserByRol(): Observable<Responses> {
    return this.http.post<Responses>(
      `${this.urlBase}auth/getCustomerAdvisorByRolByUser`,
      null
    );
  }

  getUserById(id: number): Observable<Responses> {
    return this.http.post<Responses>(`${this.urlBase}auth/getUser/${id}`, null);
  }
}
